<template>
  <div>
    <BreadcrumbsWithShareAccordion :breadcrumbs="breadcrumbs" />
    <section class="py-8 md:py-20 container">
      <h1 class="lg:block font-light text-2xl md:text-4xl mb-8 md:mb-12">
        Carta dei Servizi
      </h1>
      <div class="flex flex-col md:flex-row justify-between gap-12">
        <div class="flex-1">
          <p class="mb-4">
            UniCredit RE Services ha sottoscritto un
            <strong>impegno professionale etico e deontologico</strong> verso i
            propri Clienti, per garantire, nella
            <strong>massima trasparenza e semplicità</strong>, un elevato
            livello qualitativo di efficienza e affidabilità nei servizi
            immobiliari.
          </p>
          <p class="mb-4">
            È stata creata quindi la <strong>Carta dei Servizi</strong>, un
            documento di trasparenza che serve ad informare e a guidare il
            Cliente, individuando, in modo chiaro, semplice ed immediato,
            <strong
              >i principi, le regole e gli standard dei Servizi offerti</strong
            >.
          </p>
          <p class="mb-4">
            La carta dei servizi ha la finalità di illustrare le caratteristiche
            di un modello di servizio basato su quattro valori fondamentali
            quali
            <strong>sicurezza, trasparenza, facilità e professionalità</strong>
            che garantiscono una gestione efficace dalla relazione con il
            Cliente.
          </p>
          <p class="mb-8">
            Il nostro obiettivo è quello di rafforzare e consolidare la fiducia,
            impegnandoci ogni giorno ad offrire un servizio sempre più in linea
            con le esigenze specifiche di ciascun Cliente.
          </p>

          <UcrsAnchor
            to="/assets/pdf/Giu_24_LA_CARTA_DEI_SERVIZI_UNICREDITRES.pdf"
            target="_blank"
            label="Scarica la Carta dei Servizi"
            icon="download"
            icon-position="left"
            icon-size="md"
            class="mb-20"
          />
        </div>
        <div class="py-12 md:px-16">
          <div class="bg-white-dark px-12 py-16">
            <p class="mb-8 text-2xl text-center">4 vantaggi</p>
            <div class="pb-12">
              <div
                class="w-12 h-12 flex justify-center items-center font-bold text-lg text-white bg-blue rounded-full mb-4"
              >
                <span>1</span>
              </div>
              <p class="font-bold text-xl">Crea il tuo account gratuitamente</p>
            </div>
            <div class="pb-12">
              <div
                class="w-12 h-12 flex justify-center items-center font-bold text-lg text-white bg-blue rounded-full mb-4"
              >
                <span>2</span>
              </div>
              <p class="font-bold text-xl">
                Salva ricerche e immobili che ti interessano
              </p>
            </div>
            <div>
              <div
                class="w-12 h-12 flex justify-center items-center font-bold text-lg text-white bg-blue rounded-full mb-4"
              >
                <span>3</span>
              </div>
              <p class="font-bold text-xl">
                Rimani sempre aggiornato sulle tue preferenze
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Components
import BreadcrumbsWithShareAccordion from '~/components/BreadcrumbsWithShareAccordion.vue'
import UcrsAnchor from '~/components/UcrsAnchor.vue'

export default {
  components: {
    BreadcrumbsWithShareAccordion,
    UcrsAnchor,
  },

  async asyncData({ route, $axios }) {
    let meta
    await $axios
      .get('/_api/api/v1/meta', {
        params: {
          slug: route.path,
        },
      })
      .then((res) => {
        meta = res.data.data
      })
      .catch(() => {
        meta = {
          title:
            'Carta dei Servizi e Decalogo della Compravendita | UniCredit RE Services',
          description:
            'Scarica la Carta dei Servizi e il Decalogo della Compravendita. UniCredit RE Services garantisce un elevato livello qualitativo nei servizi immobiliari.',
        }
      })

    return { meta }
  },

  data() {
    return {
      breadcrumbs: [
        {
          text: this.$store.state.auth.loggedIn ? 'La mia homepage' : 'Home',
          href: '/',
        },
        {
          text: 'Trasparenza e Valori',
        },
      ],
    }
  },

  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
}
</script>
